import { Container, Navbar, Dropdown } from "react-bootstrap";
import Logo from '../../assets/images/logo.svg'
import { GoChevronDown } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProfileDropdown from "./ProfileDropdown";

const Header = () => {
    const navigate = useNavigate();
    const [deleteModal, setDeleteModal] = useState(false);
    const [profile_image, setProfileImage] = useState<any>(null);
    // const profile_image_url = useSelector((state: any) => state?.profile?.profile_setting?.file);
    const profile_image_url = useSelector((state: any) => state?.profile?.profile_setting);
    const [showDropdown, setShowDropdown] = useState(false);

    useEffect(() => {
        if (profile_image_url !== null || profile_image_url !== undefined) {
            setProfileImage(profile_image_url);
        }
    }, [profile_image_url]);

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="">
                            <img src={Logo} width="84" height={36} alt="Logo" />
                        </Navbar.Brand>
                        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                        <div className="d-flex align-items-center ms-auto gap-3" >
                            <Dropdown className="profile-dd"
                                show={showDropdown}
                                onToggle={() => setShowDropdown(!showDropdown)}
                            >
                                <Dropdown.Toggle onClick={() => setShowDropdown(!showDropdown)}>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <div><img src={profile_image} width={32} height={32} className=" rounded-circle object-fit-cover" alt='' /></div>
                                    </div>
                                    <GoChevronDown size={16} className='icon' />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    <ProfileDropdown closeDropdown={() => setShowDropdown(false)} />

                                    {/* <span className="dropdown-item" onClick={() => setDeleteModal(true)} style={{ cursor: "pointer" }}> */}
                                    {/* <AiOutlineLogout size={18} className="me-2" /> Logout */}
                                    {/* </span> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Navbar>
                </Container>
            </header>
        </>
    )
}
export default Header;